import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setScheduleStep } from "../../../Store/Slice/scheduleSlice";
import Button from "../../../UI/Button";
import ErrorBox from "./AlertBox";
import Form from "./Form";
import VehicleInfo from "./VehicleInfo";
import Footer from "./Footer";

export default function ScheduleVerification() {
  const dispatch = useDispatch();
  const [checkboxValue, setCheckboxValue] = useState(false);
  const scheduleStep = useSelector((state) => state.rootReducer.scheduleSlice.schedule_step);
  const { primary_contact, has_equipment, equipment_arrival_date } = useSelector((state) => state.rootReducer.scheduleSlice.sendData);
  const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((primary_contact?.email || "").trim());
  const isButtonDisabled = !(primary_contact?.firstname?.length > 0
    && primary_contact?.lastname?.length > 0
    && primary_contact?.phone?.length > 0
    && isValidEmail
    && (!has_equipment ? !has_equipment && equipment_arrival_date : has_equipment)
    && checkboxValue)

  const [showAlert, setShowAlert] = useState(false);

  const handleSubmit = (step) => {
    if (step === 4 && isButtonDisabled) return;
    dispatch(setScheduleStep(step));
  };
  return (
    <div className={`schedule__block ${scheduleStep === 3 ? "active" : ""}`}>
      <h2 className="schedule__title">
        <div>3. Verification</div>
        {scheduleStep > 3 && (
          <span onClick={() => handleSubmit(3)}>Change</span>
        )}
      </h2>
      <div className="schedule__hr"></div>
      <div className="schedule__content">
        {showAlert ? <ErrorBox /> : null}
        <div className="verify__content">
          <Form checkboxValue={checkboxValue} setCheckboxValue={setCheckboxValue} />
          <VehicleInfo />
        </div>
        <div className="lineitems__footer">
          <Button
            onClick={() => handleSubmit(4)}
            disabled={isButtonDisabled}
            text="Continue"
          />
        </div>
      </div>

      {scheduleStep > 3 ? <Footer /> : null}
    </div>
  );
}
